import Vue from 'vue'
import Vuex from 'vuex'
import Api from '../lib/api'
import StreamApi from '../lib/streamApi'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: {},
    status: {},
    token: '',
    isAuthenticated: false,
    isConnected: false,
    userListViewParams: {
      q: '',
      sort: 'username',
      direction: 1,
      page: 1,
      limit: 10,
      currentRow: -1,
      lastSeenRecordId: null
    },
    postsLoaded: false,
    newslettersLoaded: false,
    purchasables: []
  },

  mutations: {
    setUser(state, user) {
      if (user) {
        state.isAuthenticated = true
        state.user = user
      }
    },
    setStatus(state, status) {
      state.status = status
    },
    setToken(state, token) {
      state.token = token
    },
    setUserListViewParams(state, params) {
      state.userListViewParams = params
    },
    setAvatar(state, path) {
      state.user.profile.imgs.avatar = path
    },
    addFollowerCount(state, value) {
      if (state.user) {
        state.user.followers += value
      }
    },
    clearPosts(state) {
      state.user = Object.assign({}, state.user, { stickyPosts: [], posts: [] })
      state.postsLoaded = false
    },
    addPosts(state, posts) {
      if (state.user) {
        for (const p of posts) {
          if (p.sticky) {
            state.user.stickyPosts.push(p)
            continue
          }
          state.user.posts.push(p)
        }
      }
    },
    setPostsLoaded(state, loaded) {
      state.postsLoaded = loaded
    },
    clearNewsletters(state) {
      state.user = Object.assign({}, state.user, { newsletters: [] })
      state.newslettersLoaded = false
    },
    addNewsletters(state, newsletters) {
      if (state.user) {
        for (const n of newsletters) {
          state.user.newsletters.push(n)
        }
      }
    },
    setNewslettersLoaded(state, loaded) {
      state.newslettersLoaded = loaded
    },
    setPurchasables(state, data) {
      state.purchasables = data
    },
    logout(state) {
      state.isAuthenticated = false
      state.token = ''
      state.user = {
        profile: {}
      }
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated
    },
    isArtist(state) {
      return state.user ? state.user.artist : false
    },
    currentUser(state) {
      return state.user
    },
    purchasables(state) {
      return state.purchasables
    }
  },
  actions: {
    logout(context) {
      context.commit('logout')
    },
    login(context, data) {
      context.commit('setUser', data.user)
    },
    async reLogin(context, data) {
      const response = await Api.methods.apiGet('user')
      if (response && response.user) {
        context.commit('setUser', response.user)
      }
    },

    updateStatus(context, data) {
      context.commit('setStatus', data.status)
    },
    updateAvatar(context, path) {
      context.commit('setAvatar', path)
    },
    handleFollowerEvent(context, event) {
      let val = 0
      if (event.data === '"subscribe"') {
        val = 1
      } else if (event.data === '"unsubscribe"') {
        val = -1
      }
      context.commit('addFollowerCount', val)
    },
    async setInterfaceLanguage(context, code) {
      if (context.state.isAuthenticated) {
        try {
          await Api.methods.apiPost(
            `/preferences/interface-language`, {
              interfaceLanguage: code
            }
          )
        } catch (e) {
          console.log('Error setting interface language: ', e)
        }
      }
    },
    async loadProfile(context) {
      if (context.state.user.rewards) return
      const response = await Api.methods.apiGet('stream/myprofile')
      if (response && response.user) {
        context.commit('setUser', response.user)
      }
    },
    async loadPosts(context) {
      const updateStatus = async () => {
        const response = await Api.methods.apiGet('status')
        this.dispatch('updateStatus', response)
      }
      let list = []
      let counter = 0
      context.commit('clearPosts')
      StreamApi.methods.streamJson('stream/posts',
        (post) => {
          counter += 1
          if (counter === 11) {
            context.commit('addPosts', list)
            context.commit('setPostsLoaded', true)
            list = []
          }
          list.push(post)
          if (counter % 61 === 0) {
            context.commit('addPosts', list)
            list = []
          }
        },
        () => {
          if (list.length > 0) {
            context.commit('addPosts', list)
          }

          updateStatus()
        }
      )
    },
    async loadNewsletters(context) {
      const updateStatus = async () => {
        const response = await Api.methods.apiGet('status')
        this.dispatch('updateStatus', response)
      }
      let list = []
      let counter = 0
      context.commit('clearNewsletters')
      StreamApi.methods.streamJson('stream/newsletters',
        (newsletter) => {
          counter += 1
          if (counter === 11) {
            context.commit('addNewsletters', list)
            context.commit('setNewslettersLoaded', true)
            list = []
          }
          list.push(newsletter)
          if (counter % 61 === 0) {
            context.commit('addNewsletters', list)
            list = []
          }
        },
        () => {
          if (list.length > 0) {
            context.commit('addNewsletters', list)
          }

          updateStatus()
        }
      )
    },
    setPurchasables(context, data) {
      context.commit('setPurchasables', data)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js